import { useNavigate } from "react-router-dom";
import { FileText, Layout, ClipboardCheck, Users } from "lucide-react";

export default function ActionButtons() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-4 gap-6 mt-6">
      {/* Gerenciar Editais */}
      <div className="bg-white rounded-lg shadow p-6 text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-3 flex items-center justify-center">
          <FileText className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="font-semibold text-gray-900 mb-1">Gerenciar Editais</h3>
        <p className="text-xs text-gray-500 mb-3">
          Criar, editar e publicar editais
        </p>
        <button
          onClick={() => navigate("/admin/editais")}
          className="bg-blue-900 text-white px-4 py-2 rounded text-sm hover:bg-blue-800 transition-colors w-full"
        >
          Acessar
        </button>
      </div>

      {/* Gerenciar Templates */}
      <div className="bg-white rounded-lg shadow p-6 text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-3 flex items-center justify-center">
          <Layout className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="font-semibold text-gray-900 mb-1">
          Gerenciar Templates
        </h3>
        <p className="text-xs text-gray-500 mb-3">Criar e editar formulários</p>
        <button
          onClick={() => navigate("/admin/templates")}
          className="bg-blue-900 text-white px-4 py-2 rounded text-sm hover:bg-blue-800 transition-colors w-full"
        >
          Acessar
        </button>
      </div>

      {/* Analisar Inscrições */}
      <div className="bg-white rounded-lg shadow p-6 text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-3 flex items-center justify-center">
          <ClipboardCheck className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="font-semibold text-gray-900 mb-1">
          Analisar Inscrições
        </h3>
        <p className="text-xs text-gray-500 mb-3">
          Aprovar ou reprovar inscrições
        </p>
        <button
          onClick={() => navigate("/admin/inscricoes")}
          className="bg-blue-900 text-white px-4 py-2 rounded text-sm hover:bg-blue-800 transition-colors w-full"
        >
          Analisar
        </button>
      </div>

      {/* Gerenciar Proponentes */}
      <div className="bg-white rounded-lg shadow p-6 text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-3 flex items-center justify-center">
          <Users className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="font-semibold text-gray-900 mb-1">
          Gerenciar Proponentes
        </h3>
        <p className="text-xs text-gray-500 mb-3">Ver e aprovar cadastros</p>
        <button
          onClick={() => navigate("/admin/proponentes")}
          className="bg-blue-900 text-white px-4 py-2 rounded text-sm hover:bg-blue-800 transition-colors w-full"
        >
          Acessar
        </button>
      </div>
    </div>
  );
}
